module.exports = __webpack_public_path__ + "error.62474b6e.png";